'use client';
import { IDataFrameSchema } from '@/lib/dataFrameTypes';
import Input from '@/components/Input';
import { Control, FieldError } from 'react-hook-form';

const TargetFieldSelect: React.FC<{
  schema: IDataFrameSchema;
  selectedValue?: string;
  name: string;
  error?: FieldError;
  hint?: string | null;
  wide?: boolean;
  disabled?: boolean;
  control?: Control<any, any>;
  onChange?: (field: string) => void;
  label: string;
}> = ({
  schema,
  selectedValue,
  control,
  onChange,
  hint = 'Select, or create a new field to receive the output of the evaluation.',
  label,
  name,
  error,
  ...rest
}) => {
  let options = schema.fields.map((field) => ({ value: field.name, label: field.name }));

  const activeValue = selectedValue || control?._formValues[name];

  if (activeValue && !options.find((option) => option.value === activeValue)) {
    options = [{ value: activeValue, label: activeValue }, ...options];
  }
  return (
    <Input.CreateableSelect
      label={label}
      isClearable
      control={control}
      error={error}
      name={name}
      placeholder="Type to select or create"
      options={options}
      hint={hint || undefined}
      {...rest}
    />
  );
};

export default TargetFieldSelect;
